import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  marginBottom: theme.spacing(4),
  '& .TISubInfo': {
    color: theme.palette.text.secondary,
  },
  '& .TISArrowIcon': {
    fill: theme.palette.primary.main,
  },
}));
export default StyledBox;
